module.exports = __webpack_public_path__ + "static/media/4playerRoomsPlayed_500000_1000000.897c561d.png";